import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const WhoWeAre = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [captchaToken, setCaptchaToken] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // Track submission state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCaptcha = (token) => {
    setCaptchaToken(token);
  };

  const onSubmit = async (data) => {
    try {
      const response = await fetch('/api/contact/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error submitting the form:', error);
      return { type: 'error', message: 'An error occurred. Please try again.' };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setFeedback({ type: 'error', message: 'Please complete the CAPTCHA.' });
      return;
    }

    setIsSubmitting(true); // Disable submit button
    const response = await onSubmit({ ...formData, captchaToken });
    setFeedback(response);

    if (response.success) {
      setFormData({ name: '', email: '', message: '' }); // Clear form fields
      setCaptchaToken(null); // Reset CAPTCHA
    }

    setIsSubmitting(false); // Re-enable submit button
  };

  console.log ("recapcha eky",process.env.REACT_APP_RECAPTCHA_SITE_KEY)
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-100 to-gray-200 px-4">
      <div className="max-w-3xl bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-center text-blue-900 mb-6">
          Who We Are
        </h1>

        {/* Purpose Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-800 mb-4">Our Vision and Mission</h2>
          <p className="text-gray-700 text-lg leading-7 mb-4">
            Welcome to our platform! This application was born out of a personal vision and heartfelt purpose: to enhance the experience of reading and studying the Bible. As someone who deeply values the Word of God, I longed for a tool that would allow me to take notes, highlight passages, and engage with scripture in a meaningful and organized way.
          </p>
          <p className="text-gray-700 text-lg leading-7 mb-4">
            In the past, I tried leaving notes and highlights in my paper Bible, but over time, those precious insights were lost or became inaccessible. It became clear that a digital solution was needed—one that could securely and permanently preserve these reflections for future use.
          </p>
          <p className="text-gray-700 text-lg leading-7 mb-4">
            While there are existing applications for this purpose, none fully met my specific needs or aligned with my vision. This realization led me to create this platform—not just for myself but for anyone seeking a reliable, user-friendly tool to deepen their connection with scripture.
          </p>
          <p className="text-gray-700 text-lg leading-7">
            Our mission is to empower individuals to engage with the Bible on a deeper level through a secure, feature-rich application. It is our hope that this tool will be a blessing to you, just as it has been to me.
          </p>
        </section>

        {/* Creator Section */}
        <section>
          <h2 className="text-2xl font-semibold text-blue-800 mb-4">Meet the Creator</h2>
          <p className="text-gray-700 text-lg leading-7 mb-4">
            I am a bi-vocational pastor ordained in the Christian Reformed Church in North America (CRCNA). During the weekdays, I work as a web developer, using technology to serve the world. On the weekends, I fulfill my calling as a pastor, ministering to my congregation and sharing the transformative message of the Gospel.
          </p>
          <p className="text-gray-700 text-lg leading-7">
            This dual role as a pastor and developer has uniquely equipped me to create this platform. It combines my technical expertise with my passion for scripture, providing a tool that supports both personal spiritual growth and ministry.
          </p>
        </section>

        {/* Contact Us Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-800 mb-4 mt-6">Contact Us</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
              ></textarea>
            </div>

            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptcha}
            />

            <button
              type="submit"
              className="w-full py-2 px-4 bg-blue-500 text-white font-semibold rounded-md"
              disabled={isSubmitting} // Disable button during submission
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>

            {feedback && (
              <p
                className={`mt-4 text-center text-sm font-medium ${feedback.type === 'success' ? 'text-green-500' : 'text-red-500'
                  }`}
              >
                {feedback.message}
              </p>
            )}
          </form>
        </section>
      </div>
    </div>
  );
};

export default WhoWeAre;